import {
  WEB_PUSH_BANNER_DISMISSED_KEY,
  WEB_PUSH_LOGIN_PROMPT_KEY,
} from "./webPushKeys";

/**
 * When to show the desktop web-push banner for staff caregivers.
 * Not tied to login sessionStorage alone — existing sessions and token
 * refresh logins never set WEB_PUSH_LOGIN_PROMPT_KEY, which hid the prompt.
 */
export function shouldShowWebPushBanner({
  staffBellEnabled,
  supportsWebPush,
  hasUser,
  notificationPermission,
  isSubscribed,
  // GMA-1318: whether the hook's initial silent resubscribe attempt has resolved.
  // On refresh with a prior grant, isSubscribed is briefly false while that
  // attempt is in flight; showing the "re-enable" banner then makes it flash and
  // vanish before the caregiver can click it. Defaults true so existing callers
  // keep their behavior; Layout passes the live value to gate the flash.
  subscriptionChecked = true,
}) {
  if (!staffBellEnabled || !supportsWebPush || !hasUser) {
    return false;
  }
  if (notificationPermission === "unsupported") {
    return false;
  }
  if (isSubscribed && notificationPermission === "granted") {
    return false;
  }
  if (notificationPermission === "granted" && !isSubscribed) {
    // Only surface the re-enable prompt once the silent resubscribe has actually
    // resolved without establishing a subscription — not during the in-flight
    // window, which would flash the banner on every refresh.
    return subscriptionChecked;
  }
  if (notificationPermission === "denied") {
    try {
      return sessionStorage.getItem(WEB_PUSH_LOGIN_PROMPT_KEY) === "1";
    } catch (_err) {
      return false;
    }
  }
  try {
    const loginPrompt = sessionStorage.getItem(WEB_PUSH_LOGIN_PROMPT_KEY) === "1";
    const dismissed =
      sessionStorage.getItem(WEB_PUSH_BANNER_DISMISSED_KEY) === "1";
    if (loginPrompt) return true;
    if (dismissed) return false;
    return notificationPermission === "default";
  } catch (_err) {
    return notificationPermission === "default";
  }
}
